import React, { useEffect, useState } from 'react';
import IconButton from "@material-ui/core/IconButton";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import Table from "components/Table/Table.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import Close from "@material-ui/icons/Close";
import CSVReader from "react-csv-reader";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

import DatePicker from "components/Datepicker/Datepicker";
import api from "assets/services/api";

const useStyles2 = makeStyles(styles2);

const styles = {
  margintp: {
    textAlign: "right",
    marginTop: "10px"
  },
  garlic: {
    backgroundColor: "#fff7de"
  },
  smi: {
    backgroundColor: "white"
  }
};

const useStyles = makeStyles(styles);

function MyVerticallyCenteredModal(props) {
  const papaparseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
    transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
  };

  const [br, setBR] = React.useState(false);

  const classes2 = useStyles2();
  const classes = useStyles();

  const [data, setData] = useState([]);
  const [products, setProducts] = useState([]);
  const [productId, setProductId] = useState(null);
  const [amount, setAmount] = useState();
  const [price, setPrice] = useState();
  const [NF, setNf] = useState();
  const [startDate, setStartDate] = useState(new Date().withoutTime());
  const { storageId, garlicType } = useAuth();
  const [list, setList] = useState([]);
  const [totalList, setTotalList] = useState(0.0);
  const [listProducts, setListProducts] = useState([]);
  const [idOne, setIdOne] = useState(0);
  const [loading, setLoading] = useState();

  useEffect(() => {
    loadProducts();
  }, []);
  useEffect(() => {
    setList(listProducts);
    calcTotal();
  }, [listProducts, totalList])

  async function addToList(e) {
    e.preventDefault();

    if (amount === undefined || amount <= 0) {
      return alert('Quantidade inválida');
    }
    if (NF === undefined) {
      return alert('Nota fiscal inválida')
    }
    let theProduct;
    const id_product = productId ? parseInt(productId) : products[0].id
    for (let i = 0; i < products.length; i++) {
      if (products[i].id === id_product) {
        theProduct = products[i];
        break;
      }
    }
    const index = products.indexOf(theProduct);
    const price2 = price ? price : products[index].standart_price;
    const name = products[index].name;
    const storage = { NF, amount, startDate, id_product, idOne, index, name, price: price2 }
    setListProducts(prevStorage => ([...prevStorage, storage]));
  };

  async function calcTotal() {
    let total = 0;
    if (listProducts) {
      for (let i = 0; i < listProducts.length; i++) {
        total = parseFloat(total) + ((parseFloat(listProducts[i].amount)) * (parseFloat(listProducts[i].price)));
      }
    }
    setTotalList(total);
  };

  async function deleteToList(index) {
    let listNew = [...listProducts];
    listNew.splice(index, 1);
    setListProducts(listNew);
  };
  async function loadProducts() {
    if (garlicType === true) {
      const response = await api.get('/product/admin/garlic/' + storageId);
      setProducts(response.data);
    } else {
      const response = await api.get('/product/admin/' + storageId);
      setProducts(response.data);
    };
  };
  async function handleAddProduct(e) {
    e.preventDefault();
    setLoading(true);
    const response = await api.post('/storage', {
      list,
      id_admin: storageId,
    });
    if (response.status === 200) {
      props.onHide();
      props.loadStorage();
    } else {
      return alert(`Não foi possivel adicionar estoque.`)
    }
    setLoading(false);
  };
  async function cleanList() {
    let listNew = [];
    setListProducts(listNew);
  };

  const handleForce = (data, fileInfo) => {
    let storage = [];
    let total = 0.0;
    for (let i = 0; i < data.length; i++) {
      if (data[i].pedido === null) {
        alert('sem numero de nf')
        break;
      };
      const prod = products.filter(prod => parseInt(prod.new_code) === parseInt(data[i].cproduto));
      const day_split = data[i].data.split('/');
      const day = `${day_split[2]}-${day_split[1]}-${day_split[0]}`
      const final = {
        NF: data[i].nfe,
        amount: data[i].quantidade,
        date_of_issued: day,
        id_admin: storageId,
        id_product: prod[0].id,
        price: data[i].pun,
        name: prod[0].name
      };
      storage.push(final);
      console.log(data[i].quantidade, typeof data[i].quantidade, data[i].pun, typeof data[i].pun)
    };
    setListProducts(storage);
  }

  function tableData() {
    let teste = [];

    for (let i = 0; i < list.length; i++) {
      teste[i] = [];
      teste[i].push(list[i].nf);
      teste[i].push(list[i].name);
      teste[i].push(list[i].amount);
      teste[i].push(list[i].price);
      teste[i].push(
        <div className={classes2.tableActions}>
          <Tooltip
            id="tooltip-top-start"
            title="Deletar"
            placement="top"
            classes={{ tooltip: classes2.tooltip }}
          >
            <IconButton
              aria-label="Close"
              className={classes2.tableActionButton}
              onClick={() => deleteToList(i)}
            >
              <Close
                className={
                  classes2.tableActionButtonIcon + " " + classes2.close
                }
              />
            </IconButton>
          </Tooltip>
        </div>
      );
    }

    return teste;
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton style={garlicType === true ? styles.garlic : styles.smi}>
        <Modal.Title id="contained-modal-title-vcenter">
          Adicionar estoque
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={addToList}>
        <Modal.Body>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridNF">
              <Form.Label>Nota fiscal</Form.Label>
              <Form.Control onChange={event => setNf(event.target.value)} type="number" placeholder="Nota fiscal do estoque" />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridAmount">
              <Form.Label>Quantidade</Form.Label>
              <Form.Control onChange={event => setAmount(event.target.value)} type="decimal" placeholder="Quantidade de produtos" />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridPRice">
              <Form.Label>Preço</Form.Label>
              <Form.Control onChange={event => setPrice(event.target.value)} type="decimal" placeholder="Caso não preencher o preço será o padrão" />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridProduct">
              <Form.Label>Produtos</Form.Label>
              <Form.Control onChange={event => setProductId(event.target.value)} as="select" defaultValue="Choose...">
                {products.map(product => (
                  <option key={product.id} value={product.id}>{product.name}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridDate">
              <Form.Label>Data</Form.Label>
              <div>
                <DatePicker
                  selected={startDate}
                  onChange={date => setStartDate(date.withoutTime())}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Digite ou clique aqui"
                  disabledKeyboardNavigation />
              </div>
            </Form.Group>
          </Form.Row>
          <div className="d-flex justify-content-center">
            <Button color="success" type="submit">
              Adicionar a lista
            </Button>
            <Button color="success" onClick={cleanList}>
              Limpar a lista
            </Button>
          </div>
          {list === null ?
            (<Form.Row>
              Não há estoques na lista
            </Form.Row>)
            : (
              <Form.Row>
                <Table key={String("Table_storage_add")}
                  tableHeaderColor="danger"
                  tableHead={["NF", "Produto", "Quantidade", "Preço", "Ações"]}
                  tableData={tableData()}
                />
                <div className={classes.margintp}>
                  <b>Total: {totalList.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b>
                </div>
              </Form.Row>
            )
          }

        </Modal.Body>
        <Modal.Footer>
          <div className="container">
            <CSVReader
              cssClass="react-csv-input"
              onFileLoaded={handleForce}
              parserOptions={papaparseOptions}
            />
            <p>Escolher o CSV para importar</p>
          </div>
          <div className="d-flex justify-content-center">
            <Button color="success" onClick={handleAddProduct}>
              Concluir
            </Button>
            <Backdrop
              sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
              open={loading}
              onClick={() => { }}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default MyVerticallyCenteredModal;